import { CardStyleAsset } from "@1games-ru/region-shared/dist/types/bank/bank";
import { cn } from "@/core/helpers/cn";
import { imgSbankSbankClassicPlasticBg } from "@/shared/assets/img";

export function Classic({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 360 220" className={className}>
      <g clipPath="url(#a)">
        <path fill="url(#b)" d="M0 0h360v220H0z" />
        <path
          fill="url(#c)"
          fillOpacity=".3"
          d="M171 66C69 44 15 93 0 121L-31-22h88l229-5 152 5c22 23 48 80-30 122-97 53-110-6-237-34Z"
        />
        <path
          fill="url(#d)"
          fillOpacity=".5"
          d="M171 66C69 44 15 93 0 121L-31-22h88l229-5 152 5c22 23 48 80-30 122-97 53-110-6-237-34Z"
        />
        <path
          fill="url(#e)"
          fillOpacity=".3"
          d="M177 64C64 7-16 49-42 77l7-178L69-75l273 65 178 52c19 34 32 109-73 135-131 33-128-41-270-113Z"
        />
        <path
          fill="url(#f)"
          fillOpacity=".5"
          d="M177 64C64 7-16 49-42 77l7-178L69-75l273 65 178 52c19 34 32 109-73 135-131 33-128-41-270-113Z"
        />
      </g>
      <defs>
        <linearGradient id="b" x1="360" x2="-9.5" y1="220" y2="17.3" gradientUnits="userSpaceOnUse">
          <stop stopColor="#186D27" />
          <stop offset=".5" stopColor="#136221" />
          <stop offset="1" stopColor="#1B8E30" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="214.7"
          x2="214.7"
          y1="-27"
          y2="121.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#21A038" stopOpacity="0" />
          <stop offset=".5" stopColor="#21A038" stopOpacity=".3" />
          <stop offset="1" stopColor="#21A038" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="257.4"
          x2="212"
          y1="-32.2"
          y2="143.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#21A038" stopOpacity="0" />
          <stop offset=".5" stopColor="#21A038" stopOpacity=".5" />
          <stop offset="1" stopColor="#21A038" />
        </linearGradient>
        <radialGradient
          id="d"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(17 -40 77 31 295 112)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#21A038" />
          <stop offset=".5" stopColor="#21A038" stopOpacity=".2" />
          <stop offset="1" stopColor="#21A038" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="f"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(58 -21 55 153 1 29)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#21A038" />
          <stop offset=".5" stopColor="#21A038" stopOpacity=".2" />
          <stop offset="1" stopColor="#21A038" stopOpacity="0" />
        </radialGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h360v220H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Gold({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 360 220" className={className}>
      <g clipPath="url(#card-gold-a)">
        <path fill="url(#card-gold-b)" d="M0 0h360v220H0z" />
        <path
          fill="url(#card-gold-c)"
          fillOpacity=".3"
          d="M171 66C69 44 15 93 0 121L-31-22h88l229-5 152 5c22 23 48 80-30 122-97 53-110-6-237-34Z"
        />
        <path
          fill="url(#card-gold-d)"
          fillOpacity=".5"
          d="M171 66C69 44 15 93 0 121L-31-22h88l229-5 152 5c22 23 48 80-30 122-97 53-110-6-237-34Z"
        />
        <path
          fill="url(#card-gold-e)"
          fillOpacity=".3"
          d="M177 64C64 7-16 49-42 77l7-178L69-75l273 65 178 52c19 34 32 109-73 135-131 33-128-41-270-113Z"
        />
        <path
          fill="url(#card-gold-f)"
          fillOpacity=".5"
          d="M177 64C64 7-16 49-42 77l7-178L69-75l273 65 178 52c19 34 32 109-73 135-131 33-128-41-270-113Z"
        />
      </g>
      <defs>
        <linearGradient
          id="card-gold-b"
          x1="360"
          x2="-9.5"
          y1="220"
          y2="17.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#834C14" />
          <stop offset=".5" stopColor="#9C6411" />
          <stop offset="1" stopColor="#BE8200" />
        </linearGradient>
        <linearGradient
          id="card-gold-c"
          x1="214.7"
          x2="214.7"
          y1="-27"
          y2="121.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBA21" stopOpacity="0" />
          <stop offset=".5" stopColor="#FFBA21" stopOpacity=".3" />
          <stop offset="1" stopColor="#FFBA21" />
        </linearGradient>
        <linearGradient
          id="card-gold-e"
          x1="257.4"
          x2="212"
          y1="-32.2"
          y2="143.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBA21" stopOpacity="0" />
          <stop offset=".5" stopColor="#FFBA21" stopOpacity=".5" />
          <stop offset="1" stopColor="#FFBA21" />
        </linearGradient>
        <radialGradient
          id="card-gold-d"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(17 -40 77 31 295 112)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBA21" />
          <stop offset=".5" stopColor="#FFBA21" stopOpacity=".2" />
          <stop offset="1" stopColor="#FFBA21" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="card-gold-f"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(58 -21 55 153 1 29)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBA21" />
          <stop offset=".5" stopColor="#FFBA21" stopOpacity=".2" />
          <stop offset="1" stopColor="#FFBA21" stopOpacity="0" />
        </radialGradient>
        <clipPath id="card-gold-a">
          <path fill="#fff" d="M0 0h360v220H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Black({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 360 220" className={className}>
      <g clipPath="url(#card-black-a)">
        <path fill="url(#card-black-b)" d="M0 0h360v220H0z" />
        <path
          fill="url(#card-black-c)"
          fillOpacity=".02"
          d="M171 66C69.4 43.6 14.67 93.33 0 121L-31-22h88l229-5 152 5c22.33 23 47.6 79.6-30 122-97 53-110-6-237-34Z"
        />
        <path
          fill="url(#card-black-d)"
          fillOpacity=".04"
          d="M171 66C69.4 43.6 14.67 93.33 0 121L-31-22h88l229-5 152 5c22.33 23 47.6 79.6-30 122-97 53-110-6-237-34Z"
        />
        <path
          fill="url(#card-black-e)"
          fillOpacity=".02"
          d="M177.16 64.45C63.76 6.86-16.23 48.99-42.05 77.25L-35-101.5 69.15-74.57l272.57 64.12 178.37 52.4c19.4 34.06 32 108.78-72.82 135.23-131.01 33.06-128.36-40.75-270.1-112.73Z"
        />
        <path
          fill="url(#card-black-f)"
          fillOpacity=".06"
          d="M177.16 64.45C63.76 6.86-16.23 48.99-42.05 77.25L-35-101.5 69.15-74.57l272.57 64.12 178.37 52.4c19.4 34.06 32 108.78-72.82 135.23-131.01 33.06-128.36-40.75-270.1-112.73Z"
        />
      </g>
      <defs>
        <linearGradient
          id="card-black-b"
          x1="360"
          x2="-9.51"
          y1="220"
          y2="17.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#202020" />
          <stop offset=".5" stopColor="#1D1D1D" />
          <stop offset="1" stopColor="#2D2D2D" />
        </linearGradient>
        <linearGradient
          id="card-black-c"
          x1="214.75"
          x2="214.75"
          y1="-27"
          y2="121.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".3" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="card-black-e"
          x1="257.39"
          x2="212.02"
          y1="-32.24"
          y2="143.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".5" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <radialGradient
          id="card-black-d"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(17 -40 77 31 294.5 112)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".2" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="card-black-f"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(58 -21 55 153 1 29.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".2" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <clipPath id="card-black-a">
          <path fill="#fff" d="M0 0h360v220H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const tiers: Record<CardStyleAsset, React.ComponentType<{ className?: string }>> = {
  standard: Classic,
  premium: Gold,
  platinum: Black,
};

export function BankCardBg({ tier, className }: { tier: CardStyleAsset; className?: string }) {
  const Component = tiers[tier] || (() => <div>No tier</div>);

  if (tier === CardStyleAsset.Standard) {
    return (
      <img
        src={imgSbankSbankClassicPlasticBg}
        alt=""
        className={cn(className, "pointer-events-none")}
      />
    );
  }

  return <Component className={className} />;
}
